export default __webpack_public_path__ + "static/media/Darkshroud Cloak.39165f06.jpg";